import { signal } from "@angular/core";
import { BehaviorSubject } from "rxjs";
export class SpinnerServiceModel {
    numActualRequest:number = 0;
    spinnerSubject:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    message = signal<string>('');
    constructor(spinnerPageSubject:BehaviorSubject<boolean> ){
        this.spinnerSubject = spinnerPageSubject;
    }

    setMessage(text:string = ""){
        this.message.set(text);
    }

    start(){
        this.numActualRequest++;
        if(this.numActualRequest == 1){
            this.trigger(true);
        }
    }

    stop(){
        if(this.numActualRequest > 0){
            this.numActualRequest--;
        }
        if(this.numActualRequest <=0){
            this.trigger(false);
            this.message.set('');
        }    
    }

    forceStop(){
        this.clear();
    }

    trigger(value:boolean){
        this.spinnerSubject.next(value);
    }

    clear(){
        this.numActualRequest = 0;
        this.spinnerSubject.next(false);
        this.message.set('');
    }
}